// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column {
    width: 33%;
    align-self: center;
}

.expanded {
    transform: rotate(90deg);
}

.expando {
    transition: all;
    transition-duration: 0.2s;
}

  ::ng-deep .p-element.p-dropdown-item {
    width: 682px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/wizards/layout/layout.wizard.dialog.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;EAEE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".column {\n    width: 33%;\n    align-self: center;\n}\n\n.expanded {\n    transform: rotate(90deg);\n}\n\n.expando {\n    transition: all;\n    transition-duration: 0.2s;\n}\n\n  ::ng-deep .p-element.p-dropdown-item {\n    width: 682px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
